import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import lodash from 'lodash';
import {uuid as uuidv4} from '../../util/uuid';

export default function assessRiskSummaryReducer(state = initialstate.assessRiskSummary, action) {
	switch (action.type) {
		case types.GET_ALL_ASSOCIATED_RISKS_SUMMARY:
			return risksGroupedByRiskTypes(action.response);
		default:
			return state;
	}
}

const risksGroupedByRiskTypes = (state) => {
	const result = state.data?.map((element) => {
		return {
			...element,
			risks: element.risks?.map((r) => {
				return {
					...r,
					assertionsGroupedByRiskTypes: lodash
						.chain(r.assertions)
						.groupBy('account.id')
						.orderBy((group) => {
							return group[0].account.accountName;
						})
						.map((value) => {
							return {
								account: {
									key: value[0].account.id.toString(),
									hash: uuidv4()
								},
								assertionResults: value
							};
						})
						.value()
				};
			})
		};
	});

	return (
		{
			...state,
			data: result
		} || state
	);
};
